import styled from 'styled-components'
import { Skeleton } from '@sketch/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  height: 100%;
`

export const StyledSkeleton = styled(Skeleton)`
  width: auto;
  margin: 20px;
  height: 40px;
`
